export default {
  props: {
    comData: {
      type: Array,
      default() {
        return []
      }
    },
  },
  computed: {
    imgList() {
      return this.comData;
    }
  },
  data() {
    return {
      img: require('@/assets/images/img-demo.png')
    }
  }
}